<template>
  <Popup
    show="{{show}}"
    closeable="{{false}}"
  >
    <view class="success-wrap">
      <image class="shine-image" src="{{shineImg}}"  mode="widthFix"/>
      <block wx:if="{{type===1}}">
        <view class="update head">
          <image class="congratulate-image" src="{{congratulateImg}}"/>
          <image class="speed-image" src="{{speedImg}}" />
        </view>
        <view class="update content">
          <view class="from">
            <view class="title">{{curScramebleStatus.pre_status_name}}</view>
            <view class="text">领先{{curScramebleStatus.pre_percent}}%的用户</view>
          </view>
          <image class="arrow-image" src="{{arrowImg}}"  mode="widthFix"/>
          <view class="to">
            <view class="title">{{curScramebleStatus.status_name}}</view>
            <hl-text
              class="text"
              text="{{ toSpeed.text }}"
              commonStyle="{{toSpeed.commonStyle}}"
              hlStyle="{{toSpeed.hlStyle}}" 
              hlColor="{{toSpeed.hlColor}}"
            />
          </view>
        </view>
      </block>
      <block wx:if="{{type===2}}">
        <view class="help head">
          <view class="title">
            <view class="num">2</view>
            <image class="num-speed-image" src="{{numSpeedImg}}"  mode="widthFix"/>
          </view>
          <view class="tips">领先65%的抢票用户</view>
        </view>
        <view class="help content">
          <view class="photo" wx:for="{{list}}" wx:style="{{photoItemStyle}}">
          </view>
        </view>
      </block>
      <view class="btn" bindtap="close">
        <view class="btn-text">我知道了</view>
      </view>
    </view>
 </Popup>
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'
import store from '@/store'

createComponent({
  props: {
    show: {
      type: Boolean,
      value: false
    },
    type:{ // 1 速度 2 助力
      type: Number,
      value: 0
    }
  },
  computed: {
    ...store.mapState({
      curSpeedStatus: 'order.curSpeedStatus',
      curScramebleStatus:'order.curScramebleStatus',
      packageInfo: 'order.package_info',
      baseInfo: 'order.base_info',
    }),
    speedImg(){
      const _s = this.curScramebleStatus?.status
      return _s && this.speedImgAll?.[_s]
    },
    toSpeed(){
      return {
        text:`领先{{${this.curScramebleStatus.percent}%}}的用户`,
        commonStyle:{
          fontFamily: "PingFang SC",
          fontSize: '12px',
          fontWeight: 500,
          lineHeight: '12px',
          color: '#FFFFFF'
        },
        hlStyle:{
          fontFamily: 'Barlow Semi Condensed',
          fontSize: '22px',
          fontWeight: 500,
          lineHeight: '30px',
        },
        hlColor:'#FFED4C'
      }
    },
    photoItemStyle(){
      const lg = this.list.length
      let obj={}
      if(lg >= 2 && lg < 4){
        obj = {
          marginLeft:'-16px'
        }
      }
      if(lg >= 4){
        obj = {
          marginLeft:'-32px'
        }
      }
      return obj
    }
  },
  data: {
    shineImg:"https://ut-static.udache.com/webx/sfc/SRVycloESs8uAt7WibScn_guang.apng",
    congratulateImg:"https://ut-static.udache.com/webx/sfc/qY69aetA8HE27rwlmdEWx.png",
    arrowImg:"https://ut-static.udache.com/webx/sfc/A_in0MFaEJpZ_9hZvUSKf.png",
    speedImgAll:{
      '10':"https://ut-static.udache.com/webx/sfc/jLBQu-JWMLUjNDMqLrWTN.png",
      '20':"https://ut-static.udache.com/webx/sfc/84TdXv5g7-IyRi3O6h_Xh.png",
      '30':"https://ut-static.udache.com/webx/sfc/3EvZ86lTNGWQNonDH99xe.png",
      '40':"https://ut-static.udache.com/webx/sfc/wc2Zz9MG2jRSzXVQj1yWa.png",
      '50':"https://ut-static.udache.com/webx/sfc/vaNG2jM3y4k3f7nb52NmA.png"
    },
    numSpeedImg:"https://ut-static.udache.com/webx/sfc/MK05E7mdxlNCaUr29ELE-.png",
    list:['','',''],
  },
  methods: {
    close() {
      this.triggerEvent('close')
    }
  },
  watch:{
    // curSpeedStatus: {
    //   handler(val, old) {
    //     console.error('-----curSpeedStatus',val, old)
    //     if (old===undefined) {
    //       // 首次进入页面
    //       // this.progress = this.originalProgress
    //       // setTimeout(() => {
    //       //   this.progress = +val
    //       // }, 300)
    //     }else{
    //       // this.progress = +val
    //     }
    //   },
    //   immediate:true
    // },
  }
})
</script>

<style scoped lang="stylus">
.success-wrap
  width 240px
  height 320px
  background-image url('https://ut-static.udache.com/webx/sfc/cRmg_lsrDAvyRDw7coMbC.png') 
  background-size contain
  background-repeat no-repeat
  position relative
  padding 0px 20px 24px 20px
  display flex
  flex-direction column
  justify-content space-between
  border-radius: 20px;
.shine-image
  width: 445px;
  width 130vw
  position absolute
  top 50%
  left 50%
  transform translate(-50%, -50%)
  z-index -1
.update.head
  display flex
  flex-direction column
  .congratulate-image
    width 99px
    height 24px
    margin-top 39px
  .speed-image
    width 149px
    height 24px
    margin-top 9px
.update.content
  display flex
  align-items flex-end
  justify-content center
  position relative
  .from
    color: #3BB6A2;
    width: 110px;
    height: 95px;
    border-radius: 10.155px;
    background: #C2EEE5;
    box-sizing: border-box;
    border: 1px solid #98D6BA;
    display flex
    flex-direction column
    align-items center
    justify-content center
    .title
      font-family: PingFang SC;
      font-size: 18px;
      font-weight: 600;
      line-height: 18px;
    .text
      font-family: PingFang SC;
      font-size: 11px;
      font-weight: 500;
      line-height: 10px;
      margin-top 15px
  .to
    color: #FFFFFF;
    width: 130px;
    height: 110px;
    border-radius: 10.155px;
    background: linear-gradient(332deg, #FF5900 5%, #FF8C00 86%);
    margin-left -12px
    display flex
    flex-direction column
    align-items center
    justify-content center
    .title
      font-family: PingFang SC;
      font-size: 22px;
      font-weight: 600;
      line-height: 24px;
    .text
      margin-top 9px
      display flex
      flex-direction row
      align-items baseline
  .arrow-image
    width 43px
    height 30px
    position absolute
    bottom -15px
    transform translate(-15px,0)
.help.head
  display flex
  flex-direction column
  .title
    display flex
    flex-direction row
    align-items flex-end
    margin-top 27px
    .num
      font-family: Barlow Semi Condensed;
      font-size: 30px;
      font-weight: bold;
      line-height: 30px;
      color: #051C14;
      margin-right 1px
    .num-speed-image
      width: 124px;
      height: 24px;
      margin-bottom 2px
  .tips
    margin-top 9px  
.help.content
  display flex
  align-items flex-end
  justify-content center
  position relative
  .photo
    border: 3px solid #FFFFFF;
    border-radius 50% 
    width: 80px;
    height: 80px;
    background-color #FFFFFF
    .photo-img
      width: 80px;
      height: 80px;  
.btn
  height: 45px;
  border-radius: 12px;
  background: #FF5900;
  margin-bottom:10px;
  .btn-text
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 45px;
    text-align: center;
    color: #FFFFFF;
</style>

<script name="json">
module.exports = {
  component: true,
  usingComponents: {
    Popup: '@didi/spring-ui/ts-popup',
    'hl-text': '@/components/hl-text'
  }
}
</script>